module.exports = __webpack_public_path__ + "img/word.a2cb36eb.png";